import { render } from "./TagRow.vue?vue&type=template&id=50e519ca"
import script from "./TagRow.vue?vue&type=script&lang=js"
export * from "./TagRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__